"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDynamicAvStrategy = exports.getFullDynamicGates = exports.AVCLIENTSTATE_DEFAULT_PAGE_SIZE = exports.TWILIO_TOKEN_TTL_S = exports.AvStrategy = exports.VIDEO_SYSTEM_AUTOMATED_REPORT = exports.DEFAULT_GATE_VALUE = void 0;
const gate_1 = require("gather-gates/dist/src/public/gate");
exports.DEFAULT_GATE_VALUE = { exposure: 0, spaces: [] };
exports.VIDEO_SYSTEM_AUTOMATED_REPORT = "Video system automated debug reports";
var AvStrategy;
(function (AvStrategy) {
    AvStrategy["Base"] = "base";
    AvStrategy["Gather"] = "gather";
    AvStrategy["Livekit"] = "livekit";
    AvStrategy["LivekitSelfhost"] = "livekitselfhost";
})(AvStrategy || (exports.AvStrategy = AvStrategy = {}));
exports.TWILIO_TOKEN_TTL_S = 2 * 60 * 60;
exports.AVCLIENTSTATE_DEFAULT_PAGE_SIZE = 200;
const getFullDynamicGates = (dynamicGates) => ({
    livekitEnabled: dynamicGates["livekitEnabled"] ?? { exposure: 0, spaces: [] },
    livekitSelfhostEnabled: dynamicGates["livekitSelfhostEnabled"],
    gatherEnabled: dynamicGates["gatherEnabled"],
});
exports.getFullDynamicGates = getFullDynamicGates;
const calculateDynamicAvStrategy = (spaceId, gates) => {
    const baseResult = {
        avStrategy: AvStrategy.Base,
    };
    const gatherResult = {
        avStrategy: AvStrategy.Gather,
        minimumBuildTimestamp: gates.gatherEnabled?.minimumBuildTimestamp,
    };
    const livekitResult = {
        avStrategy: AvStrategy.Livekit,
        minimumBuildTimestamp: gates.livekitEnabled?.minimumBuildTimestamp,
    };
    const livekitSelfhostResult = {
        avStrategy: AvStrategy.LivekitSelfhost,
        minimumBuildTimestamp: gates.livekitSelfhostEnabled?.minimumBuildTimestamp,
    };
    if (!spaceId)
        return baseResult;
    if (gates.livekitEnabled?.spaces.includes(spaceId))
        return livekitResult;
    if (gates.livekitSelfhostEnabled?.spaces.includes(spaceId))
        return livekitSelfhostResult;
    if (gates.gatherEnabled?.spaces.includes(spaceId))
        return gatherResult;
    const livekitRunningExposure = Math.min(gates.livekitEnabled?.exposure || 0, 1.0);
    if ((0, gate_1.determineGateValueFromSeedOrExposure)("livekitEnabled", { exposure: livekitRunningExposure, space: true, seed: 11 }, { spaceId, userId: null })) {
        return livekitResult;
    }
    let runningExposure = 1.0 - livekitRunningExposure;
    const selfHostRunningExposure = Math.min((gates.livekitSelfhostEnabled?.exposure || 0) / runningExposure, 1.0);
    if ((0, gate_1.determineGateValueFromSeedOrExposure)("livekitSelfhostEnabled", { exposure: selfHostRunningExposure, space: true }, { spaceId, userId: null })) {
        return livekitSelfhostResult;
    }
    runningExposure *= 1.0 - selfHostRunningExposure;
    return gatherResult;
};
exports.calculateDynamicAvStrategy = calculateDynamicAvStrategy;
//# sourceMappingURL=av.js.map